module.exports = __webpack_public_path__ + "img/burn.24099695.svg";